
import { Component, Vue, Prop } from 'vue-property-decorator'
import { CompanyClient, CardClient } from '@/api'
import _ from 'lodash'
import BaseEditor from '@/views/BaseEditor'

@Component({
  name: 'TransferDriver',
  components: {
  }
})
export default class extends BaseEditor {
  private companyId = this.$store.state.user.companyId
  private cardClient = new CardClient()
  private cardList = []
  private company = { account_balance: 0 }
  private dialogFormVisible = true
  private searchLoading = false
  public constructor() {
    super()
    this.client = new CompanyClient()
    this.data = {
      from: this.companyId,
      name: '',
      mobile_phone_number: ''
    }
    this.rules = {
      cardId: [{ required: true, message: '收款方为必填项', trigger: 'blur' }],
      password: [{ required: true, message: '密码为必填项', trigger: 'blur' }],
      description: [{ required: true, message: '转账说明为必填项', trigger: 'blur' }],
      amount: [{ validator: this.checkTransferAmount, required: true, trigger: 'blur' }],
      name: [{ required: true, message: '查询关键字为必填项', trigger: 'blur' }]
    }
  }

  private checkTransferAmount(rule : any, value: any, callback: any) {
    if (!value || value === 0 || value === '0') {
      return callback(new Error('转账金额无效'))
    } else if (value <= 0) {
      return callback(new Error('账户余额不能小于0'))
    } else if (value > this.company.account_balance) {
      return callback(new Error('账户余额不足'))
    } else {
      return callback()
    }
  }

  async created() {
    await this.getCompany(this.companyId)
  }

  public async getCompany(id:number) {
    this.company = await this.client.get(id)
  }

  public async reset() {
    this.data = {
      from: this.companyId,
      amount: undefined,
      to: undefined,
      cardId: undefined,
      description: undefined,
      name: ''
    }
  }

  protected generateData(): any {
    const data = _.pick(this.data, [
      'amount',
      'to',
      'description',
      'password'
    ])
    return this.clearData(data)
  }

  private async search() {
    this.cardList = await this.cardClient.fetch({
      filter: {
        where: {
          isDeleted: false,
          state: '正常',
          card_number: { like: `%${this.data.card_number}%` }
        },
        fields: {
          id: true,
          card_number: true,
          username: true
        },
        order: ['createdAt']
      }
    })
  }

  private async select(row :any) {
    this.data.to = this.data.cardId = row.id
    this.dialogFormVisible = false
  }

  private async transfer() {
    const form = this.$refs['dataForm'] as any
    const companyClient = this.client as CompanyClient
    form.validate((valid:boolean) => {
      if (valid) {
        this.listLoading = true
        const card = _.find(this.cardList, (item :any) => {
          return item.id === this.data.cardId
        })

        this.$confirm('您确定要向卡号为' + card.card_number + '的卡转账' + this.data.amount + '元吗？该操作无法撤销！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async() => {
          const tempData = this.generateData()
          try {
            await companyClient.transferToCard(this.companyId, tempData)
            await this.reset()
            await this.getCompany(this.companyId)
            this.$notify({
              title: '成功',
              message: '转账成功，您可以在车队动态中查看相关记录',
              type: 'success',
              duration: 2000
            })
            this.listLoading = false
          } catch (e) {
            this.listLoading = false
            this.$notify({
              title: '失败',
              message: '转账失败，请检查您的余额是否足够或者登陆密码输入是否正确',
              type: 'error',
              duration: 2000
            })
          }
        }).catch(() => {
          this.listLoading = false
        })
      } else {
        return false
      }
    })
  }
}
